import { useCallback } from "react";

import { useMarketingCampaignFormModelContext } from "../../../../context";

export const useCampaignExplanationForHost = () => {
	const { viewModel, onSetViewModel } = useMarketingCampaignFormModelContext();

	const { voucherExplanationForHost } = viewModel;

	const onSetExplanationForHost = useCallback(
		(input: string) => {
			onSetViewModel([
				{ key: "voucherExplanationForHost", value: { ...voucherExplanationForHost, value: input } },
			]);
		},
		[voucherExplanationForHost, onSetViewModel],
	);

	return {
		voucherExplanationForHost,
		onSetExplanationForHost,
	};
};
